import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

const SangatiDetailsGraph = ({
  isOpen,
  graphYdata,
  showCompatibility,
  userPositionValue,
  matcheePositionValue,
  horizontalLineColor = "#ffffff", // Default white
  gradientColors = [
    { offset: 0, color: "#1D304D" },
    { offset: 0.5, color: "#5A1B2B" },
    { offset: 1, color: "#8E0017" },
  ], // Default to light soul gradient
}) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chartInstance = echarts.init(chartRef.current);
    const maxPosition = Math.max(
      userPositionValue ?? 0,
      matcheePositionValue ?? 0,
    );
    const dataLength = Math.max(graphYdata?.length || 106, maxPosition + 1);
    const graphXdata = Array.from({ length: dataLength }, (_, i) => i);
    const yData = isOpen ? graphYdata : Array(dataLength).fill(0);

    const option = {
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: graphXdata,
        axisLine: {
          show: true,
          lineStyle: {
            color: horizontalLineColor,
            width: 3,
          },
        },
        axisLabel: { show: false },
        axisTick: { show: false },
      },
      yAxis: {
        type: "value",
        show: false,
        splitLine: { show: false },
        axisLine: { show: false },
        axisLabel: { show: false },
        axisTick: { show: false },
      },
      series: [
        {
          data: yData,
          type: "line",
          smooth: true,
          areaStyle: {
            color: "#dfdfdf",
          },
          lineStyle: {
            color: "#93938D",
            width: 0,
          },
          symbol: "none",
        },
        ...(showCompatibility
          ? [
              {
                type: "scatter",
                data: [[matcheePositionValue, 0]],
                symbol: "rect",
                symbolSize: 14,
                itemStyle: {
                  color: "#f5bebe",
                  borderColor: "#000",
                  borderWidth: 1,
                },
                z: 10,
              },
            ]
          : []),
        {
          type: "scatter",
          data: [[userPositionValue, 0]],
          symbol: "circle",
          symbolSize: 14,
          itemStyle: {
            color: "#b2f0f0",
            borderColor: "#000",
            borderWidth: 1,
          },
          z: 10,
        },
      ],

      grid: {
        left: -20,
        right: 0,
        top: 0,
        bottom: 10,
        containLabel: false,
      },
      tooltip: { show: false },
    };

    chartInstance.setOption(option);

    const resizeChart = () => chartInstance.resize();
    window.addEventListener("resize", resizeChart);

    return () => {
      window.removeEventListener("resize", resizeChart);
      chartInstance.dispose();
    };
  }, [
    isOpen,
    graphYdata,
    showCompatibility,
    userPositionValue,
    matcheePositionValue,
    gradientColors,
    horizontalLineColor,
  ]);

  return (
    <div className="w-full text-white p-1 mt-2">
      <div
        ref={chartRef}
        style={{ width: "100%", height: isOpen ? "100px" : "20px" }}
      />
    </div>
  );
};

export default SangatiDetailsGraph;
